import { FileExtension } from "@nova/constants"
import applicationConfiguration from "configuration/application"
import { ValidMimeTypes } from "constants/files"
const { allowUploadJpgFeature } = applicationConfiguration

export const mimeTypeImageIndicator = "image/"

const infraredImageExtensions = [FileExtension.tiff, FileExtension.tif]

if (allowUploadJpgFeature) {
    infraredImageExtensions.push(FileExtension.jpg, FileExtension.jpeg)
}

infraredImageExtensions.push(
    FileExtension.irb,
    FileExtension.xml,
    FileExtension.png,
    FileExtension.owi,
    FileExtension.csv
)

// Orthomosaic (visible) uploads accept .owi (RGB) paired with MMA telemetry CSVs.
const visibleImageExtensions = [
    FileExtension.jpg,
    FileExtension.jpeg,
    FileExtension.owi,
    FileExtension.csv,
]

const orthoImageExtensions = [...visibleImageExtensions, FileExtension.tif, FileExtension.tiff]

export enum FileUploadCategory {
    All = "all",
    OrthoImages = "ortho",
    InfraredImages = "infrared",
    InfraredUpload = "infrared-upload",
    FirePerimeters = "perimeter",
    Video = "video",
    VisibleImages = "visible",
    Map = "map",
    Logo = "logo",
}

export enum FileTypes {
    KML = "kml",
    TIFF = "tiff",
    JPEG = "jpeg",
}

export const supportedFileUploadExtensions = {
    [FileUploadCategory.All]: [FileExtension.all],
    [FileUploadCategory.FirePerimeters]: [FileExtension.kml, FileExtension.kmz],
    [FileUploadCategory.InfraredUpload]: [FileExtension.kml],
    [FileUploadCategory.InfraredImages]: infraredImageExtensions,
    [FileUploadCategory.Video]: [
        FileExtension.MP4,
        FileExtension.srt,
        FileExtension.csv,
        FileExtension.gpx,
    ],
    [FileUploadCategory.VisibleImages]: visibleImageExtensions,
    [FileUploadCategory.OrthoImages]: orthoImageExtensions,
    [FileUploadCategory.Map]: [
        FileExtension.kml,
        FileExtension.kmz,
        FileExtension.shp,
        FileExtension.pdf,
    ],
    [FileUploadCategory.Logo]: [FileExtension.jpg, FileExtension.jpeg, FileExtension.png],
}

interface StringMap {
    [key: string]: string
}

export const mapExtensionsToMimeType: StringMap = {
    "*": "*",
    kml: "application/vnd.google-earth.kml+xml",
    tiff: ValidMimeTypes.Tiff,
    tif: ValidMimeTypes.Tiff,
    jpg: ValidMimeTypes.Jpeg,
    jpeg: ValidMimeTypes.Jpeg,
    mp4: "video/mp4",
    xml: "text/xml",
    png: "image/png",
    owi: "application/octet-stream",
    csv: "text/csv",
    pdf: "application/pdf",
    kmz: "application/vnd.google-earth.kmz",
    shp: "application/octet-stream",
    srt: "",
    p12: "application/x-pkcs12",
}

export const supportedMimeTypes = supportedFileUploadExtensions[FileUploadCategory.Map].map(
    (extension) => mapExtensionsToMimeType[extension]
)

export const supported16BitImageTypes = [FileExtension.tif, FileExtension.tiff, FileExtension.irb]
